"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MapLocationType = void 0;
let MapLocationType = exports.MapLocationType = /*#__PURE__*/function (MapLocationType) {
  MapLocationType["Current"] = "current location on map initialization";
  MapLocationType["CurrentButton"] = "current location on button click";
  MapLocationType["PickupPoint"] = "pickup point was selected";
  MapLocationType["PrimaryAddress"] = "primary address location on map initialization";
  MapLocationType["Searched"] = "searched location";
  MapLocationType["WhenInitialized"] = "stored location on map initialization";
  return MapLocationType;
}({});